export interface Step {
  id: string;
  number: string;
  title: string;
  description: string;
  icon: string;
}

export const STEPS: Step[] = [
  {
    id: "souscrire",
    number: "01",
    title: "Vous souscrivez",
    description:
      "Aucune résiliation nécessaire : vous conservez votre assurance actuelle, Roole s’ajoute à votre contrat pour le compléter.",
    icon: "/assets/pack-zero-franchise/step-pen.svg",
  },
  {
    id: "reparer",
    number: "02",
    title: "Vous réparez",
    description:
      "Un pépin ? Déclarez votre sinistre à votre assureur. Il règle les réparations de votre voiture comme prévu.",
    icon: "/assets/pack-zero-franchise/step-wrench.svg",
  },
  {
    id: "declarer",
    number: "03",
    title: "Vous déclarez",
    description:
      "Une fois les travaux terminés, vous nous envoyez les pièces justificatives nécessaires au remboursement.",
    icon: "/assets/pack-zero-franchise/step-file.svg",
  },
  {
    id: "rembourse",
    number: "04",
    title: "Vous êtes remboursé",
    description: "Dès validation de votre dossier, nous créditions votre compte sous 48h.",
    icon: "/assets/pack-zero-franchise/step-wallet.svg",
  },
];
